import * as React from 'react';
import { Grid } from '@mui/material';
import { FilterContainer, FilterInput, Label } from '../styledComponents';
import { BaseFilter } from './baseFilter';
import { useEffect, useState } from "react";
import { usePrevious } from '../../hooks/usePrevious';

interface UserSearchFilterProps {
    onEnter: any;
    filters: any;
    setFiltersState: any;
}

const UserSearchFilter: React.FunctionComponent<UserSearchFilterProps> = ({ onEnter, filters, setFiltersState }) => {
    const [searchTerm, setSearchTerm] = useState(filters.searchByNameOrEmail || '');

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            console.log('UserSearchFilter: Setting search term:', searchTerm);
            setFiltersState({ searchByNameOrEmail: searchTerm.length === 0 ? null : searchTerm });
        }, 1000); // 1 second debounce

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, setFiltersState]);

    // Update local state when filters change (e.g., from reset)
    useEffect(() => {
        console.log('UserSearchFilter: Filters changed, searchByNameOrEmail:', filters.searchByNameOrEmail);
        setSearchTerm(filters.searchByNameOrEmail || '');
    }, [filters.searchByNameOrEmail]);

    const prevSearchByNameOrEmail = usePrevious(filters.searchByNameOrEmail) || null;

    useEffect(() => {
        console.log('UserSearchFilter: searchByNameOrEmail changed from', prevSearchByNameOrEmail, 'to', filters.searchByNameOrEmail);
        if (filters.searchByNameOrEmail !== prevSearchByNameOrEmail) {
            console.log('UserSearchFilter: Calling onEnter');
            onEnter();
        }
    }, [
        filters.searchByNameOrEmail,
        prevSearchByNameOrEmail,
        onEnter
    ]);

    return (
        <BaseFilter title="User Search">
            <Grid container direction="column" justifyContent="space-between">
                <FilterContainer>
                    <Label>Search by Name or Email</Label>
                    <FilterInput
                        id="user-search-input"
                        InputProps={{
                            sx: { height: 48 }
                        }}
                        placeholder="Enter name or email address..."
                        value={searchTerm}
                        variant="outlined"
                        onChange={e => setSearchTerm(e.target.value)}
                        onKeyPress={ev => {
                            if (ev.key === 'Enter') {
                                onEnter(ev);
                            }
                        }}
                        type="text"
                    />
                </FilterContainer>
            </Grid>
        </BaseFilter>
    );
};

export { UserSearchFilter }; 